import './components/beam-app.js';
import './components/beam-sidebar.js';
import './components/method-card.js';
import './components/invoke-form.js';
import './components/activity-log.js';
import './components/result-viewer.js';
import './components/file-picker.js';
import './components/marketplace-view.js';
import './components/daemon-panel.js';
import './components/photon-pulse.js';
import './components/custom-ui-renderer.js';
import './components/canvas-renderer.js';
import './components/mcp-app-renderer.js';
import './components/toast-manager.js';
import './components/photon-studio.js';
import './components/studio-preview.js';
import './components/photon-config.js';
import './components/elicitation-modal.js';
import './components/overflow-menu.js';
import './components/context-bar.js';
import './components/fork-dialog.js';
import './components/app-layout.js';
import './components/inputs/date-picker.js';
import './components/inputs/tag-input.js';
import './components/inputs/star-rating.js';
import './components/inputs/segmented-control.js';
import './components/inputs/code-input.js';
import './components/inputs/markdown-input.js';

console.log('Beam UI initialized');
